module.exports = __webpack_public_path__ + "img/product.e669b0a6.png";